// extracted by mini-css-extract-plugin
export default {"card":"card-71c9"};